import { CardBrand } from '@afterpay/types'
import { PaymentIcon, PaymentIconNameMapping } from '@afterpaytouch/core'
import React, { FC } from 'react'
export interface PaymentIconsProps {
  allowedCardBrand?: CardBrand[]
}

/**
 * @experimental
 * This is only used by the arcade new payment method experiment for now
 */
export const PaymentIcons: FC<PaymentIconsProps> = ({ allowedCardBrand = [] }) => {
  if (allowedCardBrand.length === 0) {
    return null
  }
  return allowedCardBrand.map((cardType) => {
    return <PaymentIcon size='Small' name={PaymentIconNameMapping[cardType]} key={cardType} />
  })
}
